import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router';
import { Routes } from 'routes';
import { logOrgEnrollmentV2 } from 'config/analytics';

export const orgEnrollmentV2PathToScreenKey: Record<string, string> = {
    [Routes.EnrollV2]: 'wizard',
    [Routes.EnrollV2SecureAccount]: 'two_factor_send',
    [Routes.EnrollV2SecureAccountVerify]: 'two_factor_verify',
    [Routes.EnrollV2ChooseProgram]: 'choose_program',
    [Routes.EnrollV2CompletedInstant]: 'completed_instant',
    [Routes.EnrollV2CompletedMicroDeposits]: 'completed_micro_deposits',
    [Routes.EnrollV2CompletedAutomatedDeposits]: 'completed_automated_deposits',
    [Routes.EnrollV2CompletedPaperOnly]: 'completed_paper_only',
};

/**
 * Fires a PostHog screen event when the user navigates between org enrollment v2 routes.
 */
export const useOrgEnrollmentV2ScreenAnalytics = () => {
    const { pathname } = useLocation();
    const lastLoggedPath = useRef<string | null>(null);

    useEffect(() => {
        if (lastLoggedPath.current === pathname) {
            return;
        }
        lastLoggedPath.current = pathname;
        const screenKey = orgEnrollmentV2PathToScreenKey[pathname];
        if (screenKey) {
            logOrgEnrollmentV2('org_enrollment:v2_screen_viewed', { screen_key: screenKey });
        }
    }, [pathname]);
};
